import axios from 'axios';
import * as Constants from 'constants/Constants';
import { updateSession } from './sessionActions';
import * as actions from './types';

const accountServiceBaseUrl = `https://${Constants.ACCOUNT_ENDPOINT}/api/v1`;
const accountV2Path = `https://${Constants.ACCOUNT_ENDPOINT}/api/core/v2`;
const userServiceBaseUrl = `https://${Constants.USER_ENDPOINT}/api/v1`;

export const getAccounts = () => (dispatch) => {
    const url = accountServiceBaseUrl + `/accounts`;
    axios.get(url).then((res) => {
        dispatch({
            type: actions.GET_ACCOUNTS,
            payload: res.data
        });
    });
};

export const getAccount = (account) => {
    return (dispatch) => {
        dispatch(updateSession({ selected_accountId: account.id }));
        const headers = {
            'x-credential-account-id': account.id,
            Authorization: 'Bearer ' + sessionStorage.getItem('access_token')
        };
        const params = {
            filter: 'accountId',
            value: account.id,
            account_id: account.id
        };

        axios
            .create({
                baseURL: userServiceBaseUrl,
                headers
            })
            .get('/users', { params })
            .then((res) => {
                res.data.filter((accountAdmin) => {
                    return accountAdmin.user_role === 'ACCOUNT_ADMIN';
                });

                const filteredData = res.data[0];

                dispatch({
                    type: actions.GET_ACCOUNT,
                    payload: [account, filteredData]
                });
            });
    };
};

export const toggleAccountMapping = (showAddModel) => {
    return {
        type: actions.TOGGLE_ACCOUNT_MAPPING,
        payload: showAddModel
    };
};

export const closeSnackBar = () => {
    return {
        type: actions.TOGGLE_SNACKBAR,
        payload: false
    };
};

export const getAccountV2ById = (accountId) => {
    return (dispatch) => {
        const params = {
            filter: 'objectId==' + accountId
        };
        const url = accountV2Path + `/accounts`;
        axios.get(url, { params }).then((res) => {
            dispatch({
                type: actions.GET_ACCOUNT_BY_ID,
                payload: res.data.content[0]
            });
        });
    };
};
